import { render, staticRenderFns } from "./PurchaseorderList.vue?vue&type=template&id=34d2ded0&scoped=true&"
import script from "./PurchaseorderList.vue?vue&type=script&lang=js&"
export * from "./PurchaseorderList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseorderList.vue?vue&type=style&index=0&id=34d2ded0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d2ded0",
  null
  
)

export default component.exports